import { breakpoint } from '@carvana/helios-layout';
import { border, borderRadius, spacing } from '@carvana/helios-styles';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: ${spacing['6Xl']};
  padding: 0px 24px;

  ${breakpoint.sm`
    margin-bottom: ${spacing['8Xl']};
  `};

  ${breakpoint.md`
    margin: 0 auto;
    max-width: unset;
    min-width: unset;
    max-width: 1056px;
    margin-bottom: ${spacing['8Xl']};
  `};
`;

const VideoContainer = styled.div`
  align-items: center;
  border-radius: ${borderRadius.xl};
  border: 1px solid ${border.weak};
  display: flex;
  height: max-content;
  justify-content: center;
  max-width: 512px;
  min-width: 327px;
  overflow: hidden;
  position: relative;

  ${breakpoint.sm`
    max-width: unset;
    min-width: unset;
    width: 704px;
  `}

  ${breakpoint.md`
    width: 100%;
  `};
`;

export { Container, VideoContainer };
